/**
 * Coerce any value into an Array safely.
 *
 * Why this exists: the pattern `(x || []).slice(...)` — used in ~97
 * places across this codebase — only degrades gracefully when `x` is
 * falsy. If `x` is a *truthy non-array* value (a plain object like
 * `{}`, a `Map`, an axios response object accidentally stored in state
 * instead of its `.data`, or a coerced BSON shape drift on a legacy
 * record), the `|| []` fallback is skipped and `.slice()` / `.map()`
 * / `.filter()` throws:
 *
 *   Uncaught TypeError:
 *   ((intermediate value)(intermediate value)(intermediate value) || []).slice is not a function
 *
 * which propagates to the global ErrorBoundary and shows the "Something
 * went wrong on this screen" fallback. `asArray()` is the defensive
 * primitive: it returns `x` if it is already an Array; otherwise `[]`.
 *
 * NOT the same as `Array.from(x)` — we deliberately do not iterate
 * strings, Maps, or Sets. Trust-remote-JSON callers want a list of
 * plain records, not the characters of a stray string.
 */
export function asArray(x) {
  return Array.isArray(x) ? x : [];
}

export default asArray;
